export const state = () => ({
  loaded: false,
  loading: false,
  pricePlans: [],
  recurlyPricePlans: [],
});

export const getters = {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  all(state) {
    return state.pricePlans;
  },
  // eslint-disable-next-line @typescript-eslint/no-shadow
  activePlans(state) {
    return state.pricePlans.filter((p) => p.status === 'active' && !p.pause);
  },
  // Stripe-first lookup that also reaches the Recurly catalog. Only for
  // resolving a company's existing plan value; plan pickers keep using
  // `all`/`activePlans`, which stay Stripe-only.
  // eslint-disable-next-line @typescript-eslint/no-shadow
  byValue(state) {
    return (value) =>
      state.pricePlans.find((plan) => plan.value === value) ||
      state.recurlyPricePlans.find((plan) => plan.value === value);
  },
};

export const mutations = {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  setPricePlans(state, pricePlans) {
    state.pricePlans = pricePlans;
    state.loaded = true;
  },

  // eslint-disable-next-line @typescript-eslint/no-shadow
  setRecurlyPricePlans(state, recurlyPricePlans) {
    state.recurlyPricePlans = recurlyPricePlans;
  },

  // eslint-disable-next-line @typescript-eslint/no-shadow
  setLoading(state, bool) {
    state.loading = bool;
  },
};

export const actions = {
  async fetch(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    { commit, state }
  ) {
    const status = ['active', 'deprecated'];
    const internal = true;
    const partner = '__all__';

    const { loaded, loading } = state;
    if (loaded || loading) {
      return state.pricePlans;
    }

    commit('setLoading', true);

    try {
      const baseParams = {
        internal,
        partner,
        status: status.join(','),
      };

      const [stripeResult, recurlyResult] = await Promise.allSettled([
        this.$axios.get('/billing/billing/v2/price-plans', {
          params: baseParams,
          baseURL: `${process.env.PUBLICAPI_URL}`,
        }),
        this.$axios.get('/billing/billing/v2/price-plans', {
          params: {
            ...baseParams,
            billing: 'recurly',
          },
          baseURL: `${process.env.PUBLICAPI_URL}`,
        }),
      ]);

      if (stripeResult.status === 'rejected') {
        throw stripeResult.reason;
      }

      commit('setPricePlans', stripeResult.value.data);

      if (recurlyResult.status === 'rejected') {
        console.warn(
          'pricePlans/fetch: Recurly catalog failed to load; plan lookups for Recurly-billed companies stay empty.',
          recurlyResult.reason
        );
      } else {
        commit('setRecurlyPricePlans', recurlyResult.value.data);
      }

      return [...stripeResult.value.data];
    } finally {
      commit('setLoading', false);
    }
  },

  /**
   * The plans lead checkout can sell: every core plan in the Recurly catalog, one entry per
   * headcount band, priced by Recurly (BIO-1864, `billing=recurly`). Not cached in the store, which
   * every other page shares for looking up existing customers' plans.
   */
  async fetchRecurlySellable() {
    const res = await this.$axios.get('/billing/billing/v2/price-plans', {
      params: {
        internal: true,
        partner: '__all__',
        status: ['active', 'deprecated'].join(','),
        billing: 'recurly',
      },
      baseURL: `${process.env.PUBLICAPI_URL}`,
    });

    return [...res.data];
  },
};
